module.exports = __webpack_public_path__ + "img/logo_text_En.e3e056c3.png";